import PrivateAPI from './private';

export const getUserByEmail = (email) => {
  return PrivateAPI.post(`/api/users/email/`, {'email': email})
}

export const getUserPendingOrders = () => {
  return PrivateAPI.get('/api/users/pending-orders/?items_per_page=100')
}
